import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { t } from '../../utils/translations';
import Button from '../ui/Button';
import { actionIcon } from '../ui/actionIcons';

interface CounselorsPageHeaderProps {
  canAdd: boolean;
  onAdd: () => void;
}

const CounselorsPageHeader: React.FC<CounselorsPageHeaderProps> = ({ canAdd, onAdd }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
    <div>
      <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900 sm:text-3xl">
        <UserGroupIcon className="h-7 w-7 text-brand-gold sm:h-8 sm:w-8" />
        {t.counselors.pageTitle}
      </h1>
      <p className="mt-1 text-sm text-slate-500">{t.counselors.subtitle}</p>
    </div>

    {canAdd && (
      <Button
        variant="primary"
        icon={actionIcon.add}
        onClick={onAdd}
        className="w-full sm:w-auto"
      >
        {t.counselors.addCounselor}
      </Button>
    )}
  </div>
);

export default CounselorsPageHeader;
